import InstagramEmbed from '../InstagramEmbed/InstagramEmbed';
import TwitterEmbed from '../TwitterEmbed/TwitterEmbed';
import VideoEmbedPlayer from '../VideoEmbedPlayer/VideoEmbedPlayer';

import { SocialEmbedsPropTypes } from './SocialEmbeds.types';

const SocialEmbeds: React.FC<SocialEmbedsPropTypes> = ({ data, className }) => {
  switch (data?.platform) {
    case 'Instagram':
      return <InstagramEmbed data={data} className={className} />;
    case 'Twitter':
      return <TwitterEmbed data={data} className={className} />;
    case 'Contentful':
    case 'YouTube':
    case 'Vimeo':
    case 'Dailymotion':
    case 'Wistia':
    case 'Twitch':
    case 'Facebook Video':
    case 'Loom':
    case 'Brightcove':
    case 'JWPlayer':
    case 'Vidyard':
      return <VideoEmbedPlayer data={data} className={className} />;
    default:
      return null;
  }
};

export default SocialEmbeds;
